// extracted by mini-css-extract-plugin
export default {"backdrop":"ShareModal_backdrop__gTGgI","link":"ShareModal_link__PUe6Z"};